import { IconChecklist16 } from '@warp-ds/icons/react/checklist-16';
import { IconFilter16 } from '@warp-ds/icons/react/filter-16';
import { Button } from '@warp-ds/react/components/button';
import dynamic from 'next/dynamic';
import type { PropsWithChildren, ReactNode } from 'react';
import { thousandSeparated } from '../util/formatting';
import type { MapProps } from './interfaces';

// Dynamically import the shared map component to avoid SSR issues
const DynamicMap = dynamic(() => import('shared/map/ClientSideMap'), {
    ssr: false,
    loading: () => (
        <div className="flex items-center justify-center s-bg-subtle w-full h-full">
            <span className="s-text-subtle">Laster kart...</span>
        </div>
    ),
});

export type ResultPageMapProps = {
    showFilters: boolean;
    toggleFilters: () => void;
    resultList: ReactNode;
    filters: ReactNode;
    numberOfOffers?: number;
    closeMapUrl: string;
};

export const ResultPageMap = ({
    showFilters,
    toggleFilters,
    resultList,
    filters,
    numberOfOffers,
    closeMapUrl,
    children,
    ...rest
}: PropsWithChildren<ResultPageMapProps & MapProps>) => (
    <div className="flex flex-col md:flex-row result-page-map-container">
        <div className="flex flex-col result-page-map-sidebar">
            <div className="flex items-center justify-between p-16 border-b md:border-b-0 s-border">
                <Button utility small href={closeMapUrl} className="flex items-center gap-8" data-testid="showListButton">
                    <IconChecklist16 />
                    Vis i liste
                </Button>
                {numberOfOffers ? (
                    <span className="text-14" data-testid="numberOfResults">
                        {thousandSeparated(numberOfOffers)} treff
                    </span>
                ) : null}
                <Button utility small onClick={toggleFilters} className="flex items-center gap-8" data-testid="toggleFilterButton">
                    <IconFilter16 />
                    Filter
                </Button>
            </div>
            <div className="hidden md:block overflow-y-auto">{resultList}</div>
        </div>
        <div className="flex-1 relative">
            <DynamicMap {...rest} className="result-page-map">
                {children}
            </DynamicMap>
            <div
                className={`result-page-map-filter-overlay ${showFilters ? 'result-page-map-filter-overlay-open' : ''} s-bg`}
                aria-hidden={!showFilters}
                data-testid="resultPageMapFilterOverlay">
                {showFilters && <div className="overflow-y-auto">{filters}</div>}
            </div>
        </div>
    </div>
);
